export const TransactionTypeEnum = {
  Charge: 0,
  Cash: 1,
  Credit: 2,
  UndoCharge: 3,
  RedoCharge: 4,
  OfflineCharge: 5,
  OfflineCash: 6,
  OfflineCredit: 7,
  Check: 8,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/TransactionTypeEnum.js